(function () {
  'use strict';

  var warmedCount = 0;
  var warmImages = [];

  function findTarget(node) {
    while (node && node !== document) {
      if (node.nodeType === 1 && node.getAttribute('data-ss-hero-srcset') !== null) return node;
      node = node.parentNode;
    }
    return null;
  }

  function shouldSkip() {
    return document.prerendering || (navigator.connection && navigator.connection.saveData);
  }

  function warmHero(event) {
    var target = findTarget(event.target);
    var image;

    if (!target || target.getAttribute('data-ss-hero-warmed') === 'true') return;
    if (warmedCount >= 6 || shouldSkip()) return;

    target.setAttribute('data-ss-hero-warmed', 'true');
    warmedCount += 1;

    image = new Image();
    image.decoding = 'async';
    image.sizes = target.getAttribute('data-ss-hero-sizes');
    image.srcset = target.getAttribute('data-ss-hero-srcset');
    warmImages.push(image);
  }

  document.addEventListener('pointerover', warmHero, false);
  document.addEventListener('touchstart', warmHero, { passive: true });
})();
